import React, { useEffect, useMemo, useState } from "react"
import { useHistory, useLocation, useParams } from "react-router-dom"

import Button from "../../components/Button/Button"
import communityServices from "../../services/community"
import { paths } from "../../routes/paths"

import styles from "./index.module.scss"

const PeerCircleInvitationActionPage = () => {
  const { uuid } = useParams()
  const location = useLocation()
  const history = useHistory()
  const [status, setStatus] = useState("loading")
  const [message, setMessage] = useState("Processing your response...")
  const [errorDetails, setErrorDetails] = useState("")

  const action = useMemo(() => {
    return location.pathname.endsWith("/decline") ? "decline" : "accept"
  }, [location.pathname])

  useEffect(() => {
    let isMounted = true

    const handleAction = async () => {
      setStatus("loading")
      setMessage("Processing your response...")
      setErrorDetails("")

      try {
        if (action === "accept") {
          await communityServices.acceptPeerCircleInvitation(uuid)
        } else {
          await communityServices.declinePeerCircleInvitation(uuid)
        }

        if (!isMounted) return

        setStatus("success")
        setMessage(
          action === "accept"
            ? "Peer circle invitation accepted."
            : "Peer circle invitation declined.",
        )
      } catch (error) {
        if (!isMounted) return

        const responseMessage =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong. Please try again."

        setStatus("error")
        setMessage("We couldn't process your response.")
        setErrorDetails(responseMessage)
      }
    }

    handleAction()

    return () => {
      isMounted = false
    }
  }, [action, uuid])

  const title =
    action === "accept" ? "Accept Invitation" : "Decline Invitation"

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <p className={styles.label}>Peer Circle Invitation</p>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.message}>{message}</p>
        {status === "error" && errorDetails && (
          <p className={styles.errorDetails}>{errorDetails}</p>
        )}

        <div className={styles.actions}>
          {status === "success" && (
            <>
              <Button
                buttonStyle="contained"
                onClick={() => history.push(paths.communityTopic(uuid))}
              >
                View Peer Circle
              </Button>
              <Button
                buttonStyle="outlinedBlack"
                onClick={() => history.push(paths.notifications)}
              >
                Go to Notifications
              </Button>
            </>
          )}
          {status === "error" && (
            <>
              <Button buttonStyle="contained" onClick={() => history.go(0)}>
                Try Again
              </Button>
              <Button
                buttonStyle="outlinedBlack"
                onClick={() => history.push(paths.notifications)}
              >
                Back to Notifications
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default PeerCircleInvitationActionPage
